import React from 'react';
import EntryGuidePrintButton from '../EntryGuides/EntryGuidePrintButton';

const SalesServiceOrderPrintButton = ({ orderId, className }) => (
  <EntryGuidePrintButton
    className={className}
    title="Imprimir"
    onClick={() =>
      window.open(`/ventas/service-orders/${orderId}/print`, '_blank', 'noopener,noreferrer')
    }
  />
);

export default SalesServiceOrderPrintButton;
